// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@property --color-one {
  syntax: "<color>";
  inherits: false;
  initial-value: #ff136d;
}
@property --color-two {
  syntax: "<color>";
  inherits: false;
  initial-value: #453fd6;
}
.styles_button__BM1ak {
  --color-one: #ff136d;
  --color-two: #453fd6;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 100%;
  transition: --color-one 0.8s, --color-two 0.8s;
  background: linear-gradient(264.11deg, var(--color-one) -2.87%, var(--color-two) 105.13%);
  border-radius: 16px;
  box-shadow: -20px 10px 30px rgba(69, 63, 214, 0.15), 20px -10px 30px rgba(255, 19, 109, 0.15);
}
.styles_button__BM1ak:hover {
  --color-one: #453fd6;
  --color-two: #ff136d;
}
.styles_button__BM1ak:focus {
  --color-one: #453fd6;
  --color-two: #ff136d;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.26), rgba(0, 0, 0, 0.26)), linear-gradient(264.11deg, #443de9 -2.87%, #ff136d 105.13%);
}
.styles_button__BM1ak:disabled {
  background: rgba(255, 255, 255, 0.03);
  box-shadow: none;
}
.styles_button__BM1ak:disabled .styles_text__qr0to {
  color: rgba(255, 255, 255, 0.3);
}

.styles_text__qr0to {
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.9);
}
@media (max-width: 768px) {
  .styles_text__qr0to {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/btnGradient/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,iBAAA;EACA,eAAA;EACA,sBAAA;AAFF;AAKA;EACE,iBAAA;EACA,eAAA;EACA,sBAAA;AAHF;AAMA;EACE,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,8CAAA;EACA,yFAAA;EACA,mBAAA;EACA,6FAAA;AAJF;AAME;EACE,oBAAA;EACA,oBAAA;AAJJ;AAOE;EACE,oBAAA;EACA,oBAAA;EACA,wIAAA;AALJ;AAQE;EACE,qCCxCM;EDyCN,gBAAA;AANJ;AAQI;EACE,+BCxCK;ADkCX;;AAWA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BC/CS;ADuCX;AEjBE;EFmBF;IASI,eAAA;EAPF;AACF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n@property --color-one {\n  syntax: '<color>';\n  inherits: false;\n  initial-value: #ff136d;\n}\n\n@property --color-two {\n  syntax: '<color>';\n  inherits: false;\n  initial-value: #453fd6;\n}\n\n.button {\n  --color-one: #ff136d;\n  --color-two: #453fd6;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  height: 100%;\n  transition: --color-one 0.8s, --color-two 0.8s;\n  background: linear-gradient(264.11deg, var(--color-one) -2.87%, var(--color-two) 105.13%);\n  border-radius: 16px;\n  box-shadow: -20px 10px 30px $blue-btn-15, 20px -10px 30px $pink-15;\n\n  &:hover {\n    --color-one: #453fd6;\n    --color-two: #ff136d;\n  }\n\n  &:focus {\n    --color-one: #453fd6;\n    --color-two: #ff136d;\n    background: linear-gradient(0deg, $black-26, $black-26), linear-gradient(264.11deg, $blue -2.87%, $pink 105.13%);\n  }\n\n  &:disabled {\n    background: $white-3;\n    box-shadow: none;\n\n    .text {\n      color: $white-30;\n    }\n  }\n}\n\n.text {\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-90;\n\n  @include md {\n    font-size: 16px;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `styles_button__BM1ak`,
	"text": `styles_text__qr0to`
};
export default ___CSS_LOADER_EXPORT___;
